export default {
  getCursorX (state) {
    return state.cursor_x
  }
}
